import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { BlogsRoutingModule } from './blogs-routing.module';
import { BlogsListComponent } from './blogs-list/blogs-list.component';
import { BlogsCreateComponent } from './blogs-create/blogs-create.component';

@NgModule({
  declarations: [BlogsListComponent, BlogsCreateComponent],
  imports: [
    CommonModule,
    BlogsRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class BlogsModule { }
